export const BASE_DELAY = 20;
export const DESKTOP_WIDGET_MIN_WIDTH = 640;
export const MOBILE_WIDGET_MIN_WIDTH = 280;
export const BULK_REQUEST_LIMIT = 500;
